import { firebaseApp } from './Firebase'
import 'firebase/compat/remote-config'

export enum ConfigValue {
  appConfigHost = 'app_config_host',
  deepLinkDomain = 'deep_link_domain',
  deepLinkItem = 'deep_link_item',
  shareAndroidPackage = 'share_android_package',
  shareIOSId = 'share_ios_id',
  shareIOSPackage = 'share_ios_package',
  shopifyApiBaseUrl = 'shopify_api_base_url',
  shopifyApiToken = 'shopify_api_token',
  defaultDynamicLink = 'default_dynamic_link'
}

export const utmAppname = 'gmn' // Google Campaign source
export const dynamicLinksService = 'https://dynamic-links.live.goodmorningnight.app'
export const remoteConfig = firebaseApp.remoteConfig()
remoteConfig.settings.minimumFetchIntervalMillis = 30000 // 3600000

// staging:
// remoteConfig.defaultConfig = {
//   app_config_host: 'https://staging.goodmorningnight.app',
//   deep_link_domain: 'https://share.goodmorningnight.app',
//   deep_link_item: 'https://goodmorningnight.app/detail/{itemId}',
//   share_android_package: 'app.goodmorningnight',
//   share_ios_id: '6443877715',
//   share_ios_package: 'app.goodmorningnight',
//   shopify_api_base_url: 'https://spruche-app-de.myshopify.com',
//   shopify_api_token: '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',
//   default_dynamic_link: 'https://share.staging.goodmorningnight.app/getApp'
// }

// live:
remoteConfig.defaultConfig = {
  app_config_host: 'https://live.goodmorningnight.app',
  deep_link_domain: 'https://withlove.goodmorningnight.app',

  // The following values don't exist in firebase anymore
  deep_link_item: 'https://goodmorningnight.app/detail/{itemId}',
  share_android_package: 'app.goodmorningnight',
  share_ios_id: '6480112282',
  share_ios_package: 'app.goodmorningnight',
  shopify_api_base_url: 'https://spruche-app-de.myshopify.com',
  shopify_api_token: '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',
  default_dynamic_link: 'https://withlove.goodmorningnight.app'
}

remoteConfig.fetchAndActivate()
